import { cn } from "@/app/lib/utils";

interface ConnectionStatusProps {
  isConnected: boolean;
  isConnecting: boolean;
  error: string | null;
}

export function ConnectionStatus({
  isConnected,
  isConnecting,
  error,
}: ConnectionStatusProps) {
  if (isConnecting) {
    return (
      <div className="flex items-center" title="Connecting...">
        <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center" title={`Disconnected: ${error}`}>
        <div className="w-2 h-2 bg-red-500 rounded-full" />
      </div>
    );
  }

  if (isConnected) {
    return (
      <div className="flex items-center" title="Connected">
        <div className="w-2 h-2 bg-green-500 rounded-full" />
      </div>
    );
  }

  return (
    <div className="flex items-center" title="Offline">
      <div className="w-2 h-2 bg-gray-400 rounded-full" />
    </div>
  );
}